<template>
  <div class="module-part">
    <div>
      <div v-for="(group, i) in groups" :key="i" class="group-btns">
        <p style="color: red; margin-bottom:16px;">
          {{ "按钮组" + (i + 1) }}
        </p>
        <el-upload
          :ref="'groupActive' + i"
          :show-file-list="false"
          action="#"
          class="uploadicon"
          accept=".png"
          :limit="1"
          :http-request="file => handleGroupChoseFile(file, i)"
        >
          <i class="el-icon-plus icon-container" v-if="!group.activeImage"></i>
          <img
            :src="createImage(group.activeImage)"
            v-else
            class="img-container"
          />
        </el-upload>
        <el-upload
          :ref="'groupInactive' + i"
          :show-file-list="false"
          action="#"
          class="uploadicon"
          accept=".png"
          :limit="1"
          :http-request="file => handleGroupChoseFile1(file, i)"
        >
          <i
            class="el-icon-plus icon-container"
            v-if="!group.inactiveImage"
          ></i>
          <img
            :src="createImage(group.inactiveImage)"
            v-else
            class="img-container"
          />
        </el-upload>
        <el-input
          size="small"
          class="input-width"
          placeholder="功能名称"
          v-model="group.name"
        />
        <el-input
          class="input-width"
          size="small"
          placeholder="功能描述"
          v-model="group.desc"
        />
        <div class="btn-group-operation">
          <el-button
            :disabled="i == 0"
            size="mini"
            plain
            type="primary"
            @click="move(i, 'up')"
            >上移</el-button
          >
          <el-button
            :disabled="i == groups.length - 1"
            size="mini"
            plain
            type="primary"
            @click="move(i, 'down')"
            >下移</el-button
          >
          <el-button size="mini" plain type="danger" @click="deleteGroup(i)"
            >删除</el-button
          >
        </div>
        <div>
          <div v-for="(item, index) in group.btnList" :key="index" class="btns">
            <!-- 操作 -->
            <div class="btn-operation">
              <span class="btn-span">{{ "按钮" + (index + 1) }}</span>
              <div>
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="handleDelete(i, index)"
                ></el-button>
                <el-button
                  size="mini"
                  type="primary"
                  :disabled="index == 0"
                  icon="el-icon-top"
                  @click="handleMove('up', i, index)"
                ></el-button>
                <el-button
                  size="mini"
                  type="primary"
                  :disabled="index == group.btnList.length - 1"
                  icon="el-icon-bottom"
                  @click="handleMove('down', i, index)"
                ></el-button>
              </div>
            </div>
            <!-- 配置 -->
            <div>
              <!-- 名称 -->
              <span class="btn-title">按钮状态</span>
              <el-upload
                :ref="'active' + index"
                :show-file-list="false"
                action="#"
                class="uploadicon"
                accept=".png"
                :limit="1"
                :http-request="file => handleChoseFile(file, i, index)"
              >
                <i
                  class="el-icon-plus icon-container"
                  v-if="!item.activeImage"
                ></i>
                <img
                  :src="createImage(item.activeImage)"
                  v-else
                  class="img-container"
                />
              </el-upload>
              <el-upload
                :ref="'inactive' + index"
                :show-file-list="false"
                action="#"
                class="uploadicon"
                accept=".png"
                :limit="1"
                :http-request="file => handleChoseFile1(file, i, index)"
              >
                <i
                  class="el-icon-plus icon-container"
                  v-if="!item.inactiveImage"
                ></i>
                <img
                  :src="createImage(item.inactiveImage)"
                  v-else
                  class="img-container"
                />
              </el-upload>
              <el-input
                size="small"
                class="input-width"
                placeholder="功能名称"
                v-model="item.name"
              />
              <!-- 类型 -->
              <el-select v-model="item.type" size="small" class="input-width">
                <el-option
                  v-for="type in types"
                  :key="type.value"
                  :value="type.value"
                  :label="type.label"
                ></el-option>
              </el-select>
              <!-- 页面 type == 2 -->
              <el-select
                v-model="item.secondImageId"
                class="input-width"
                v-if="item.type == 2"
                size="small"
                @change="
                  val => {
                    handleChangePageType(i, index, val);
                  }
                "
              >
                <el-option
                  v-for="page in pages"
                  :key="page.id"
                  :value="page.id"
                  :label="handlePageName(page)"
                ></el-option>
              </el-select>
              <!-- 属性 type == 1 -->
              <el-select
                v-model="item.propertyId"
                class="input-width"
                v-if="item.type == 1"
                @change="(propertyId) => handlePropertyChange(propertyId, i, index)"
                size="small"
              >
                <el-option
                  v-for="type in propertes"
                  :key="type.id"
                  :value="type.id"
                  :label="type.propertyName"
                ></el-option>
              </el-select>
              <el-select
                v-model="item.code"
                class="input-width"
                v-if="item.propertyType == 5"
                size="small"
              >
                <el-option
                  v-for="enums in item.bounds"
                  :key="enums.key"
                  :value="enums.key"
                  :label="enums.value"
                ></el-option>
              </el-select>
              <!-- 外链 type == 3 -->
              <el-input
                size="small"
                class="input-width"
                v-model="item.linkUrl"
                v-if="item.type == 3"
              ></el-input>
              <el-button
                type="danger"
                plain
                size="small"
                @click="() => addContent(i, index)"
                >说明内容配置</el-button
              >
            </div>
            <div>
              <span class="btn-title">展示图标</span>
              <el-upload
                :ref="'type' + index"
                :show-file-list="false"
                action="#"
                class="uploadicon"
                accept=".png"
                :limit="1"
                :http-request="file => handleChoseFile2(file, i, index)"
              >
                <i
                  class="el-icon-plus icon-container"
                  v-if="!item.typeImage"
                ></i>
                <img
                  :src="createImage(item.typeImage)"
                  v-else
                  class="img-container"
                />
              </el-upload>
            </div>
          </div>
        </div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="handleAddBtn(i)"
        ></el-button>
      </div>
      <el-button size="small" plain type="primary" @click="addGroup"
        >新增按钮组</el-button
      >
    </div>
    <ContentEdit
      @set="setContent"
      :propertes="propertes"
      v-if="contentVisible"
      :visible.sync="contentVisible"
      :content="content"
    />
  </div>
</template>

<script>
let currentGroupIndex, currentItemIndex;
import ContentEdit from "./ContentEdit";
export default {
  props: ["propertes", "pages", "row"],
  components: {
    ContentEdit
  },
  data() {
    return {
      groups: [
        {
          name: "",
          desc: "",
          activeImage: "",
          inactiveImage: "",
          btnList: [
            {
              activeImage: "",
              inactiveImage: "",
              name: "",
              type: "",
              typeImage: '',
              propertyId: "", // 属性ID
              secondImageId: "", // 页面Id
              desc: "", // 辅助描述
              pageType: "", // 页面类型
              linkUrl: "", // 外链
              type: "",
              content: []
            }
          ]
        }
      ],
      types: [
        {
          value: 1,
          label: "属性"
        },
        {
          value: 2,
          label: "页面"
        },
        {
          value: 3,
          label: "外链"
        },
        {
          value: 5,
          label: "弹窗"
        }
      ],
      contentVisible: false,
      content: {}
    };
  },
  created() {
    if (Array.isArray(this.row)) {
      this.groups = this.$utils.deepClone(this.row);
      this.groups.forEach((group, i) => {
        group.btnList.forEach((btn, index) => {
          if (btn.propertyType == 5) {
            this.handlePropertyChange(btn.propertyId, i, index)
          }
        })
      })
    }
  },
  methods: {
    handlePropertyChange(propertyId, i, index) {
      let property = this.propertes.filter((el) => el.id == propertyId)[0]
      this.groups[i].btnList[index].propertyType = property.type
      if (property.type == 5) {
        let bounds
        try {
          bounds = JSON.parse(property.bounds)
          if (typeof bounds !== 'object') {
            bounds = {}
          }
        } catch {
          bounds = {}
        }
        let keys = Object.keys(bounds.items)
        this.groups[i].btnList[index].bounds = keys.map((el) => {
          return {
            key: Number(el), 
            value: bounds.items[el]
          }
        })
      }
    },
    createImage(fileName) {
      return fileName ? this.$store.state.standard.fileLoad + fileName : "";
    },
    deleteGroup(i) {
      this.groups.splice(i, 1);
    },
    addGroup() {
      this.groups.push({
        name: "",
        desc: "",
        activeImage: "",
        inactiveImage: "",
        btnList: [
          {
            activeImage: "",
            inactiveImage: "",
            name: "",
            type: "",
            typeImage: '',
            propertyId: "", // 属性ID
            propertyType: "", // 属性类型
            secondImageId: "", // 页面Id
            desc: "", // 辅助描述
            pageType: "", // 页面类型
            linkUrl: "", // 外链
            type: "",
            content: [],
            bounds: [],
          }
        ]
      });
    },
    move(i, type) {
      let list = this.$utils.handleMoveArr(this.groups, type, i);
      this.$set(this, "groups", list);
    },
    // 移动按钮
    handleMove: function(fun, i, idx) {
      let list = this.$utils.handleMoveArr(this.groups[i].btnList, fun, idx);
      this.$set(this.groups[i], "btnList", list);
    },
    handleDelete: function(i, index) {
      this.groups[i].btnList.splice(index, 1);
    },
    async handleGroupChoseFile(file, groupIndex) {
      let fileName = await this.upload(file);
      if (fileName) {
        this.groups[groupIndex].activeImage = fileName;
      }
      this.$refs["groupActive" + index][0].clearFiles();
    },
    async handleGroupChoseFile1(file, groupIndex) {
      let fileName = await this.upload(file);
      if (fileName) {
        this.groups[groupIndex].inactiveImage = fileName;
      }
      this.$refs["groupInactive" + index][0].clearFiles();
    },
    async handleChoseFile(file, groupIndex, itemIndex) {
      let fileName = await this.upload(file);
      if (fileName) {
        this.groups[groupIndex].btnList[itemIndex].activeImage = fileName;
      }
      this.$refs["active" + index][0].clearFiles();
    },
    async handleChoseFile1(file, groupIndex, itemIndex) {
      let fileName = await this.upload(file);
      if (fileName) {
        this.groups[groupIndex].btnList[itemIndex].inactiveImage = fileName;
      }
      this.$refs["inactive" + index][0].clearFiles();
    },
    async handleChoseFile2(file, groupIndex, itemIndex) {
      let fileName = await this.upload(file);
      if (fileName) {
        this.groups[groupIndex].btnList[itemIndex].typeImage = fileName;
      }
      this.$refs["type" + index][0].clearFiles();
    },
    async upload(file) {
      const formData = new FormData();
      formData.append("files", file.file);
      let res = await this.$http.uploadFiles(formData);
      return res.data.success && res.data.data.toString();
    },
    addContent(groupIndex, itemIndex) {
      currentGroupIndex = groupIndex;
      currentItemIndex = itemIndex;
      this.content = this.$utils.deepClone(
        this.groups[groupIndex].btnList[itemIndex].content
      );
      this.contentVisible = true;
    },
    setContent(content) {
      this.groups[currentGroupIndex].btnList[
        currentItemIndex
      ].content = content;
    },
    // 新增
    handleAddBtn: function(i) {
      this.groups[i].btnList.push({
        activeImage: "",
        inactiveImage: "",
        name: "",
        type: "",
        typeImage: "",
        propertyId: "", // 属性ID
        propertyType: '',
        secondImageId: "", // 页面Id
        desc: "", // 辅助描述
        pageType: "", // 页面类型
        linkUrl: "", // 外链
        type: "",
        content: [],
        bounds: [],
      });
    },
    handleSubmit() {
      return this.groups;
    },
    // 转译页面名称
    handlePageName: function(page) {
      let type = this.$utils.escapePageName(page.type);
      let nvgName = page.nvgName;
      if (page.inner) {
        return type;
      } else {
        return nvgName + "-" + type;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.group-btns {
  position: relative;
  margin-bottom: 16px;
  .btn-group-operation {
    position: absolute;
    top: 0;
    right: 0;
  }
  .btns {
    position: relative;
    .btn-title {
      font-size: 12px;
      color: #999;
      display: inline-block;
      margin-right: 8px;
    }
    .btn-operation {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 8px 0;
      .btn-span {
        font-size: 12px;
      }
    }
  }
}
.uploadicon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #666;
  font-size: 12px;
  margin-right: 8px;
  border: 1px dashed #d9d9d9;
  width: 28px;
  height: 28px;
  .icon-container {
    width: 28px;
    height: 28px;
    line-height: 28px;
  }
  .img-container {
    width: 28px;
    height: 28px;
    font-size: 0;
    display: inline-block;
    vertical-align: -10px;
    line-height: 0;
  }
}
.input-width {
  width: 150px;
  margin-right: 8px;
  margin-bottom: 8px;
}
</style>
